import axios from 'axios'
import nhost from 'lib/nhost-client'

const getWalletTokens = async (walletAddress, tokenAddress?) => {
  let token_found = false
  let token_ids: number[] = []
  try {
    const url = `${nhost.functions.url}/check-nft-existence?address=${walletAddress}${
      tokenAddress ? `&tokenAddress=${tokenAddress}` : ''
    }`
    const response = await axios.get(url)
    token_found = response?.data?.token_found
    token_ids = response?.data?.token_ids.map((item) => Number(item)) || []
  } catch (err) {
    token_found = false
    token_ids = []
  }
  return { token_found, token_ids }
}

export default getWalletTokens
